import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MusicPlayer from './MusicPlayer';
import LanguageSwitcher from './LanguageSwitcher';
import { authStore } from '../services/accountApi';
import './Header.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [authUser, setAuthUser] = useState(authStore.getUser());

  // ログイン/ログアウト時にヘッダー表示を更新する
  useEffect(() => {
    const handler = () => setAuthUser(authStore.getUser());
    window.addEventListener('auth-changed', handler);
    return () => window.removeEventListener('auth-changed', handler);
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/" className="header-title-link">
            <h1 className="header-title">Planning Poker</h1>
          </Link>
        </div>
        <div className="header-center">
          <Link to="/teams" className="header-link">
            <svg
              className="header-link-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            チーム
          </Link>
          <Link to="/jira-settings" className="header-link">
            <svg
              className="header-link-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            {t('header.jiraSettings') || 'JIRA設定'}
          </Link>
        </div>
        <div className="header-right">
          <MusicPlayer />
          <LanguageSwitcher />
          {authUser ? (
            <Link to="/teams" className="header-user">
              {authUser.display_name}
            </Link>
          ) : (
            <Link to="/login" className="header-user">
              ログイン
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
